import { ReactElement } from 'react';

export function ChevronLeftIcon(): ReactElement {
  return (
    <svg fill='#757575' height='10' width='6' xmlns='http://www.w3.org/2000/svg'>
      <path d='M.104 5c0-.293.116-.574.323-.781L4.402.243a.737.737 0 011.042 1.042L1.803 4.926a.104.104 0 000 .148l3.641 3.64a.737.737 0 01-1.042 1.043L.427 5.78A1.101 1.101 0 01.104 5z' />
    </svg>
  );
}
